<template>
  <div>
    <div v-if="name">
      <strong class="inner-title">{{ name }}</strong>
    </div>
    <b-row class="mb-3">
      <!-- seleziona forma di pagamento -->
      <div>
        <base-select
          :id="conf.id"
          :vid="'select' + conf.id"
          name="type"
          label="Tipo Cassa"
          v-model="inputVal.type"
          :options="conf.options"
          @select="onSelect"
          @remove="onRemove"
        />
      </div>
      <!-- ammontare -->
      <div>
        <base-currency
          :id="'bc-' + conf.id"
          :vid="'currency' + conf.id"
          name="amount"
          label="Importo"
          v-model="inputVal.amount"
          :options="{ currency: 'EUR', locale: 'it-IT' }"
          placeholder="Inserisci un importo"
          :disabled="!inputVal.type"
          :rules="inputVal.type ? rules : {}"
        />
      </div>
      <div
        class="form-group col-md-2 align-self-end"
        v-if="inputVal.type && canDelete"
      >
        <b-button
          class="btn--smaller btn--transparent btn-reset"
          style="border: none; border-radius: 999rem; padding: 0; margin: 0; height: 40px; width: 40px;"
          size="sm"
          :title="`${
            name
              ? `Rimuovi la &quot;${name}&quot;`
              : 'Rimuovi la forma di pagamento'
          }`"
          @click="onDelete(conf.id)"
        >
          <base-icon name="trash" width="22" height="22"></base-icon>
        </b-button>
      </div>
    </b-row>
  </div>
</template>
<script>
import BaseIcon from "@/components/BaseIcon";
import BaseCurrency from "@/components/form/BaseCurrency";
import BaseSelect from "@/components/form/BaseSelect";

export default {
  inject: ["canDelete"],
  props: {
    value: undefined,
    name: String,
    conf: Object,
    // canDelete: {
    //   type: Boolean,
    //   default: false,
    // },
    rules: Object,
  },
  components: {
    BaseIcon,
    BaseCurrency,
    BaseSelect,
  },
  data() {
    return {
      id: null,
    };
  },
  mounted() {},
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    onSelect(selectedOption, id) {
      // console.debug("entryDetail select onSelect", selectedOption, id);
      this.$emit("select", selectedOption, id);
    },
    onRemove(removedOption, id) {
      // console.debug("entryDetail select onRemove", removedOption, id);
      this.$emit("unselect", removedOption, id);
    },
    onDelete(id) {
      this.$emit("delete", id);
    },
  },
};
</script>
<style scoped lang="scss">
.inner-title {
  display: block;
  font-weight: bold;
  margin: 0 0 5px;
}
</style>
